import { render, staticRenderFns } from "./admin-deliveries.vue?vue&type=template&id=299af278&scoped=true"
import script from "./admin-deliveries.vue?vue&type=script&lang=js"
export * from "./admin-deliveries.vue?vue&type=script&lang=js"
import style0 from "./admin-deliveries.vue?vue&type=style&index=0&id=299af278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299af278",
  null
  
)

export default component.exports